import React from 'react'

import { CmsPage, RenderCmsComponent } from 'bloomreach-experience-react-sdk'
import getConfig from 'next/config'

import { WebPage } from '@grandvision/analytics'
import { Stores as StoresApi } from '@grandvision/api-client'
import { DefaultPageProps, getPageSeo, QueryParams } from '@grandvision/bloomreach'
import { PageRoutes } from '@grandvision/routing'
import { StoreModel } from '@grandvision/store-model'
import { StoreFinder } from '@grandvision/stores'

import componentDefinitions from '../cms/component-definitions'
import Layout from '../components/Layout'
import { getBookAppointmentUrl, getStoreDetailUrl } from '../util/store-utils'

const { publicRuntimeConfig } = getConfig()
const apiUrl = publicRuntimeConfig.grandvision.apiUrl || ''
const selfUrl = publicRuntimeConfig.selfUrl || ''

type Props = DefaultPageProps & {
  search: QueryParams
  stores: StoreModel[]
}

const StoresPage = ({ pageModel, asPath, preview, request, stores, search, pageRoutes }: Props) => {
  if (!pageModel) {
    console.error('No page model defined for stores page! (uses home page model)')
    return null
  }

  const routes: PageRoutes = pageRoutes || ({} as PageRoutes)
  const initialValue = search.search
  const seoData = getPageSeo(pageModel)

  return (
    <CmsPage
      cmsUrls={publicRuntimeConfig.bloomreach.cmsUrls}
      pageModel={pageModel}
      request={request}
      componentDefinitions={componentDefinitions}
    >
      {() => (
        <Layout asPath={asPath} isSolaris={false} pageModel={pageModel} preview={preview}>
          <RenderCmsComponent path="main/top-container" />

          <div className="site-container stores-layout">
            <StoreFinder
              emailHidden
              stores={stores}
              initialValue={initialValue}
              getBookAppointmentUrl={getBookAppointmentUrl(routes['book-appointment'] || '')}
              getStoreDetailUrl={getStoreDetailUrl(routes.stores || '')}
              searchWhitelist={['postalCode', 'streetName', 'town', 'storeName']}
              showUseMyLocation={true}
            />
          </div>

          <RenderCmsComponent path="bottom/top-container" />

          <WebPage url={selfUrl + asPath} name={seoData.title} pageType={'StoreLocator'} />
        </Layout>
      )}
    </CmsPage>
  )
}
StoresPage.getInitialProps = async ({ asPath, query }) => {
  const { pageModel, request, search, pageRoutes, preview } = query
  let stores: StoreModel[] = []
  try {
    stores = await StoresApi.list(`${apiUrl}/stores`)
  } catch (err) {
    console.log(`failed to fetch stores: ${err}`)
  }

  return {
    asPath,
    pageModel,
    preview,
    request,
    search,
    stores,
    pageRoutes,
  }
}

export default StoresPage
